import { render, staticRenderFns } from "./NodePopupCaseStudy.vue?vue&type=template&id=870cb56a"
import script from "./NodePopupCaseStudy.vue?vue&type=script&lang=js"
export * from "./NodePopupCaseStudy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports